import { applicationUrl } from "@constants";

import { IUserDetails } from "@types";

export const getSwitchUserUrl = (userId: IUserDetails["id"], redirectUrl: string) =>
  `${applicationUrl}/user/switch/${userId}?redirect_url=${encodeURIComponent(redirectUrl)}`;
